// Module
var code = "<div id=\"V-957A2690-27AE-404B-B9EE-B9E56760A07F\" style=\"background-color:#add8e6\"> <h3>Guage</h3> </div> ";
// Exports
export default code;